module.exports = __webpack_public_path__ + "img/erin_minuskin_swjiqc_PuCHl.275cda6f.jpg";